import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {MessageItem} from "../../components/other/CommentsContainer/CommentsContainer";

interface ChatState {
    chats: any[];
    messages: MessageItem[];
    selectedChatId: number | null;
    tabNotifications: { id: string, new_comments_count: string }[];
}

const initialState: ChatState = {
    chats: [],
    messages: [],
    tabNotifications: [],
    selectedChatId: null,
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setTabNotifications(state, action: PayloadAction<{ id: string, new_comments_count: string }[]>) {
            state.tabNotifications = action.payload;
        },
        setChats(state, action: PayloadAction<any[]>) {
            state.chats = action.payload;
        },
        setMessages(state, action: PayloadAction<MessageItem[]>) {
            state.messages = action.payload;
        },
        pushToTopMessages(state, action: PayloadAction<MessageItem[]>) {
            state.messages = [...state.messages, ...action.payload];
        },
        pushToBottomMessages(state, action: PayloadAction<MessageItem[]>) {
            state.messages = [...action.payload, ...state.messages];
        },
        setSelectedChatId(state, action: PayloadAction<number | null>) {
            state.selectedChatId = action.payload;
        },
        clearAll(state) {
            state.chats = [];
            state.messages = [];
            state.tabNotifications = [];
            state.selectedChatId = null;
        }
    },
});

export const { setChats, setMessages, setSelectedChatId, pushToBottomMessages, pushToTopMessages, setTabNotifications } = chatSlice.actions;
export default chatSlice.reducer;